import {
    SETING_MENU_PREMIUM_POST,
    SETING_MENU_PREMIUM_GET,
    SETING_MENU_PREMIUM_GET_ALL,
    SETING_MENU_PREMIUM_PUT,
    SETING_MENU_PREMIUM_DELETE,
    SETING_MENU_PREMIUM_PUT_LOADING,
    SETING_MENU_PREMIUM_SORT,
    SETTING_MENU_PREMIUM_RATIO_SETTING
} from '../constants/ActionTypes'

const initialState = {
    data: [],
    pointRatio: [],
    menuPremiumExist: false,
}

export const SettingMenuPremium = (state = initialState, action) => {
    let ret = [...state.data]
    let flag = false
    switch (action.type) {
        case SETING_MENU_PREMIUM_PUT_LOADING:
            ret = state.data.map((cur) =>
                cur.id === action.data.id ? { ...cur, ...action.data } : cur
            )
            if (!ret.some((cur) => cur.id === action.data.id)) {
                ret.push(action.data)
            }
            return { ...state, data: ret }
        case SETING_MENU_PREMIUM_POST:
            if (typeof action.data.id !== 'undefined') {
                ret.push(action.data)
            }
            return { ...state, data: ret }

        case SETING_MENU_PREMIUM_SORT:
            return { ...state, data: ret }
        case SETING_MENU_PREMIUM_GET:
        case SETING_MENU_PREMIUM_GET_ALL:
            return  { ...state, data: action.data };
        case SETING_MENU_PREMIUM_PUT:
            return { ...state, data: ret }
        case SETING_MENU_PREMIUM_DELETE:
            ret = state.data.filter((cur) => cur.id !== action.data)
            return { ...state, data: ret }
        case SETTING_MENU_PREMIUM_RATIO_SETTING:
            return { ...state, pointRatio: action.data }
        default:
            return state
    }
}
